import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_VEHICLE_BODYTYPES_DATA, FETCH_VEHICLE_BODYTYPES_EDIT_DATA } from "./actionTypes";
import {
  fetchVehiclesBodyTypesSuccess,
  fetchVehiclesBodyTypesFailure,
  fetchVehiclesBodyTypesEditSuccess,
  fetchVehiclesBodyTypesEditFailure,
} from "./actions";

function* fetchVehiclesBodyTypesDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/vehicles-bodytypes",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchVehiclesBodyTypesSuccess(response.data));
  } catch (error) {
    yield put(fetchVehiclesBodyTypesFailure(error.message));
  }
}

function* fetchVehiclesBodyTypesEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/vehicles-bodytypes/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchVehiclesBodyTypesEditSuccess(response.data));
  } catch (error) {
    yield put(fetchVehiclesBodyTypesEditFailure(error.message));
  }
}

export default function* vehiclesBodyTypesSaga() {
  yield takeEvery(FETCH_VEHICLE_BODYTYPES_DATA, fetchVehiclesBodyTypesDataSaga);
  yield takeEvery(FETCH_VEHICLE_BODYTYPES_EDIT_DATA, fetchVehiclesBodyTypesEditDataSaga);
}
